<template>
    <PaginatedList
        itemClass="translation-list"
        :items="sections"
        :filterItemsFn="filterSections"
        :page.sync="page"
        :perPage.sync="perPage"
        @update:pagination="onPaginationChange"
    >
      <template #item="{ item }">
          <TranslationListItem 
            :section="item"
            :filterFn="filterKeys"
            @change="onChange"
          />            
      </template>
      <template #footer-right>
        <div class="flex gap-2">
          <v-button
            :text="$t('actions.back')"
            class="py-2"
            outline
            :disabled="page <= 1"
            @click="changePage(-1)"
          />

          <v-button
            v-if="checkPermission('localization.edit')"
            :text="isLastPage ? $t('actions.save') : $t('actions.save_n_next')"
            class="py-2"
            type="primary"
            @click="handleSave(1)"
          />
          <v-button
            v-else
            :text="$t('actions.next')"
            class="py-2"
            type="primary"
            :disabled="isLastPage"
            @click="changePage(1)"
          />
        </div>
      </template>
    </PaginatedList>
</template>

<script>

import Button from "@shared/components/button";
import PaginatedList from './paginated-list';
import TranslationListItem from './translation-list-item.vue';
import { checkPermission } from "@shared/utils/functions";

export default {
  name: 'TranslationList',
  components: {
    TranslationListItem,
    PaginatedList,
    'v-button': Button
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    saveMethod: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      filterKeyAttr: 'label',
      filterSectionAttr: 'label',
      page: 1,
      perPage: 10,
      pagesCount: 1,
    };
  },
  computed: {
    isLastPage() {
      return this.page >= this.pagesCount;
    },
  },
  methods: {
    checkPermission,

    filterKeys({ array, filter }) {
      return array.filter((item) => (item[this.filterKeyAttr] || '').toLowerCase().includes(filter.toLowerCase()));
    },
    filterSections({ array, filter }) {
      return array.filter((item) => (item[this.filterSectionAttr] || '').toLowerCase().includes(filter.toLowerCase()));
    },
    changePage(pageDelta) {
      this.page = Math.min(Math.max(1, this.page + pageDelta), this.pagesCount);
    },
    async handleSave(pageDelta) {
      if (!checkPermission('localization.edit')) return;

      try {
        await this.saveMethod?.();
        this.changePage(pageDelta);
        this.$emit('save');
      } catch (error) {
        console.error("Error saving translation:", error);
      }
    },
    onChange(payload) {
      this.$emit('change', payload);
    },
    onPaginationChange(payload) {
      this.pagesCount = payload.pagesCount;
    },
  }
};

</script>

<style lang="scss">
.list_item.translation-list {
    background-color: #ffffff!important;
}
</style>